import React, { FC } from "react";

import { colors } from "@joinTrilo/ui/tokens";

type Props = {
    color?: keyof typeof colors;
};

const Lock: FC<Props> = ({ color = "white" }) => (
    <svg
        width="11"
        height="16"
        viewBox="0 0 11 16"
        fill={colors[color]}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.86579 16H9.13421C10.3747 16 11 15.3583 11 14.0026V8.54851C11 7.20311 10.3747 6.56144 9.13421 6.56144H1.86579C0.625346 6.56144 0 7.20311 0 8.54851V14.0026C0 15.3583 0.625346 16 1.86579 16ZM1.39422 7.27556H2.8397V4.37775C2.8397 2.36998 4.12115 1.38681 5.49488 1.38681C6.87885 1.38681 8.17054 2.36998 8.17054 4.37775V7.27556H9.61603V4.58472C9.61603 1.41784 7.55544 0 5.49488 0C3.44454 0 1.39422 1.41784 1.39422 4.58472V7.27556Z"
            fill="white"
        />
    </svg>
);

export default Lock;
